var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',[(_vm.loading)?_c('div',{staticClass:"loader"}):_c('div',[_vm._v(" "+_vm._s(_vm.buttonTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }